
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[company-slug]/guides/[slug]",
      function () {
        return require("private-next-pages/[company-slug]/guides/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[company-slug]/guides/[slug]"])
      });
    }
  